import { Flex, Tag } from "@chakra-ui/react";
import { AuthPermissionGuard } from "../../../../shared/components/AuthPermissionGuard";
import Page, { PageTab } from "../../../../shared/components/Page";
import { declareAiTabDestination } from "../../../ai-omnibar/ai-tab-destinations";
import ReferralsDashboardRoute from "../../../referral/pages/dashboard/ReferralsDashboardRoute";
import ParallelCallsV2Route from "../parallel-calls/ParallelCallsV2Route";
import IntakeDashboardRoute from "./IntakeDashboardRoute";
import IntakePlanReferralsRoute from "./IntakePlanReferralsRoute";

// The tabs saying they are somewhere to go. Intake opens on its patient list, so the three beside
// it are only reachable by name if they say so themselves.
[
  {
    id: "intakePlanReferrals.open",
    title: "Open the Intake plan referrals tab",
    stateName: "app.patients.intake.plans",
    opens: "page:intakePlanReferrals",
    description: "Opens Patients > Intake > Plan Referrals, the referrals that came in by plan.",
    examples: ["open plan referrals"],
  },
  {
    id: "intakeParallelDialer.open",
    title: "Open the Intake parallel dialer tab",
    stateName: "app.patients.intake.parallel-calls",
    opens: "page:intakeParallelDialer",
    description:
      "Opens Patients > Intake > Parallel Dialer, the experimental screen for calling several intake patients at once.",
    examples: ["open the parallel dialer"],
  },
  {
    id: "intakeReferralUsers.open",
    title: "Open the Intake referral users tab",
    stateName: "app.patients.intake.referral-users",
    opens: "page:intakeReferralUsers",
    description:
      "Opens Patients > Intake > Referral Users, the people who send the agency referrals.",
    examples: ["open referral users"],
  },
].forEach((tab) =>
  declareAiTabDestination({
    ...tab,
    location: "the tab bar of Intake",
    permissionKey: "view_patient_page_intake",
  })
);

const tabs: PageTab[] = [
  {
    header: "Intake Patients",
    route: "app.patients.intake.dashboard",
    component: <IntakeDashboardRoute />,
  },
  {
    header: "Plan Referrals",
    route: "app.patients.intake.plans",
    component: (
      <AuthPermissionGuard permission="view_patient_page_intake">
        <IntakePlanReferralsRoute />
      </AuthPermissionGuard>
    ),
  },
  {
    header: (
      <Flex gap={2}>
        Parallel Dialer{" "}
        <Tag colorScheme="blue" size="sm">
          Experimental
        </Tag>
      </Flex>
    ),
    route: "app.patients.intake.parallel-calls",
    component: (
      <AuthPermissionGuard permission="view_patient_page_intake">
        <ParallelCallsV2Route />
      </AuthPermissionGuard>
    ),
  },
  {
    header: "Referral Users",
    route: "app.patients.intake.referral-users",
    component: (
      <AuthPermissionGuard permission="view_patient_page_intake">
        <ReferralsDashboardRoute />
      </AuthPermissionGuard>
    ),
  },
];

export default function IntakeRoute() {
  return <Page.Tabbed tabs={tabs} />;
}
